import * as React from "react"
const SvgFilter = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M11 20.857a.97.97 0 0 1-.712-.287.97.97 0 0 1-.288-.713v-6l-5.8-7.4q-.375-.5-.112-1.05c.263-.55.479-.55.912-.55h14q.65 0 .913.55.262.55-.113 1.05l-5.8 7.4v6a.97.97 0 0 1-.287.713.97.97 0 0 1-.713.287zm1-7.7 4.95-6.3h-9.9z" />
  </svg>
)
export default SvgFilter
